import RaikoBaseCardContainer from "../../raikoComponents/raikoBaseCardContainer/RaikoBaseCardContainer";
import RaikoLabel from "../../raikoComponents/raikoCustomLabel/RaikoLabel";
import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";
import ButtonDivisionSection from "../../component/ButtonDivisionSection/ButtonDivisionSection";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import {css} from "@emotion/css";
import {useEffect, useState} from "react";
import RaikoDefaultDialogPage, {DialogSize} from "../../component/defaultDialogPage/RaikoDefaultDialogPage";
import SliderAddNewItem from "./SliderAddNewItem";
import {
    createCollapsedTableRowData,
    RaikoCollapsibleTable
} from "../../raikoComponents/raikoCollapsibleTable/RaikoCollapsibleTable";
import {convertUniversalDateToPersianDate} from "../../util/DateConvertor";
import RaikoCustomSimpleActiveDeActiveChip
    from "../../raikoComponents/raikoCustomChip/raikoCustomSimpleActiveDeactiveChip/RaikoCustomSimpleActiveDeActiveChip";
import {SliderService} from "../../serverService/sliderService/SliderService";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import SliderItemDetail from "./SliderItemDetail";


export default function SliderItemsList({id}) {

    const size = 15
    let page = 0

    const service = new SliderService()
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())

    useEffect(() => {
        if (typeof id !== 'undefined' && id >= 0) {
            getDataFromServer()
        }
    }, [id]);

    function getDataFromServer() {
        setTableLoading(true)
        service.getSliderItemsList(id, page, size)
            .then(response => {
                setPageCount(response.totalPage)
                setTableListItems([])
                response.data.map((item, index) => {
                    setTableListItems(prevState => [
                        ...prevState,
                        prepareTableItem(
                            item.id,
                            (page * size) + index + 1,
                            item.thumbnail && item.thumbnail.url ? item.thumbnail.url : "",
                            item.title,
                            item.createdAt,
                            item.createdBy,
                            item.published
                        )
                    ])
                })
                setTableLoading(false)
            }).catch(reason => {

            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در دریافت لیست اسلاید ها"))
            setTableLoading(false)
        })
    }


    function prepareTableItem(id, number, url, title, createdDate, creator, publishState) {
        return createCollapsedTableRowData(
            id,
            <SliderItemDetail
                id={id}
                handleUpdateRowGlobalInfo={response => {
                    /*const items = tableListItems
                    setTableListItems([])

                    items.map((item, index) => {
                        if (item.id === id) {
                            let _item = items[index]
                            _item.title = response.title
                        }
                    })

                    setTableListItems(items)*/
                }}

                handleUpdateThumbnailUrl={thumbnailUrl => {
                    /* const items = tableListItems
                     setTableListItems([])

                     items.map((item, index) => {
                         if (item.id === id) {
                             let _item = items[index]
                             _item.thumbnail = <img
                                 className={css`
                                   max-width: 100px;
                                   border-radius: 8px;
                                   object-fit: contain;
                                 `}
                                 src={thumbnailUrl}
                                 alt={title}/>
                         }
                     })

                     setTableListItems(items)*/
                }}

                handleUpdatePublishedState={state => {
                    /*const items = tableListItems
                    setTableListItems([])

                    console.log("state is ", state)

                    items.map((item, index) => {
                        console.log("begin for fund it ", items)
                        if (item.id === id) {
                            console.log("found it !!!")
                            let _item = items[index]
                            _item.publishedState = "asdasda"

                        }
                    })

                    setTableListItems(items)*/
                }}
            />,
            {
                id,
                number,
                thumbnail: <div className={css`
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  align-items: center;
                  width: 100%;
                `}>
                    <div
                        className={css`
                          width: 100px;
                          border-radius: 8px;
                          background: var(--color-primary-highlight);

                        `}>
                        {
                            url && url.length > 0 ?
                                <img
                                    className={css`
                                      max-width: 100px;
                                      border-radius: 8px;
                                      object-fit: contain;
                                    `}
                                    src={url}
                                    alt={title}/> :

                                <div className={`ic-picture ${css`margin: 1rem`}`}/>
                        }
                    </div>
                </div>,
                title,
                createdDate: convertUniversalDateToPersianDate(createdDate),
                creator,
                publishedState: <RaikoCustomSimpleActiveDeActiveChip
                    deActiveStateTitle={"منتشر نشده"}
                    activeStateTitle={"منتشر شده"} state={publishState}/>
            }
        )
    }

    const [tableListItems, setTableListItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [tableLoading, setTableLoading] = useState(false);


    const [addDialogOpenState, setAddDialogOpenState] = useState(false);

    function handleOpenDialogState() {
        setAddDialogOpenState(true)
    }

    function handleCloseDialogState() {
        setAddDialogOpenState(false)
    }

    function handleChangePagination(rowId) {

    }

    function handleAddNewItem(newItem) {
        if (page === 0) {
            const _itemsList = tableListItems
            setTableListItems([])
            _itemsList.map((item, index) => {

                if (index === 0) {
                    setTableListItems([
                        prepareTableItem(
                            newItem.id,
                            1,
                            "",
                            newItem.title,
                            newItem.createdAt,
                            newItem.createdBy,
                            false
                        )
                    ])
                }

                setTableListItems(prevState => [
                    ...prevState,
                    {
                        ...item,
                        number: (page * size) + index + 2
                    }
                ])
            })
        }
    }


    return (
        <>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialogState}
                open={addDialogOpenState}
                pageTitle={"افزودن اسلاید جدید"}
                dialogSize={DialogSize.SMALL}>
                <SliderAddNewItem sliderId={id} handleCloseDialog={handleCloseDialogState}
                                  handleAddItem={handleAddNewItem}/>
            </RaikoDefaultDialogPage>
            <RaikoBaseCardContainer>
                <RaikoGridOneColumn>
                    <ButtonDivisionSection className={css`align-items: center`}>
                        <RaikoLabel text={"اسلاید ها"} className={css`flex-grow: 1;`}/>
                        <ButtonPrimaryRaiko label={"افزودن"} onClick={handleOpenDialogState}/>
                    </ButtonDivisionSection>
                    <RaikoCollapsibleTable
                        data={tableListItems}
                        header={columns}
                        isLoading={tableLoading}
                        pageCount={pageCount}
                        handlePaginationChange={handleChangePagination}/>
                </RaikoGridOneColumn>
            </RaikoBaseCardContainer>
        </>
    )
}


const columns = [
    {
        id: 'number',
        label: '#'
    }, {
        id: 'thumbnail',
        label: 'تصویر شاخص'
    }, {
        id: 'title',
        label: 'عنوان'
    }, {
        id: 'createdDate',
        label: 'تاریخ ساخت'
    }, {
        id: 'creator',
        label: 'سازنده',
    }, {
        id: 'publishedState',
        label: 'وضعیت انتشار',
    },
];

